import {
  HoldingClassInvestmentsConsiderationValues,
  InvestmentAllocation,
  InvestorAllocationTotals,
} from '../../types';
import { CurrencyCode } from 'further-types/lp/vehicle';
import { Typography } from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { realisation as rules } from 'further-ui/validations';
import useFormatInvestorAllocationsData from './InvestmentSplitPerInvestorTable/useFormatInvestorAllocationsData';
import InvestmentSplitPerInvestorTable from './InvestmentSplitPerInvestorTable';
import PerInvestorAllocationTable from '../../AllocationTables/PerInvestorAllocationTable';
import PerClassAllocationTable from '../../AllocationTables/PerClassAllocationTable';
import TypographyButton from 'further-ui/components/TypographyButton';

type Props = {
  holdingClassInvestmentsConsiderationValues: Array<HoldingClassInvestmentsConsiderationValues>;
  investorAllocationsTotals: Array<InvestorAllocationTotals>;
  currency: CurrencyCode;
  considerationIndex: number;
};

const AllocationsTableSection: React.FC<Props> = ({
  holdingClassInvestmentsConsiderationValues,
  investorAllocationsTotals,
  currency,
  considerationIndex,
}) => {
  const { getValues } = useFormContext<rules.CreateRealisationFormValues>();
  const [showPerInvestor, setShowPerInvestor] = useState(false);
  const holdingClassRealisations = getValues('holdingClassRealisation');

  const { formatInvestorAllocationsData } = useFormatInvestorAllocationsData();
  const tableData = formatInvestorAllocationsData(considerationIndex);

  const flatInvestmentAllocations = getValues(
    `consideration.${considerationIndex}.investorAllocations`,
  ) as Array<InvestmentAllocation> | undefined;

  const groupedPerInvestmentAllocations = Object.values(tableData);

  return (
    <>
      <Typography variant="h5">Per class allocation</Typography>
      <PerClassAllocationTable
        holdingClassRealisations={holdingClassRealisations}
        holdingClassInvestmentsConsiderationValues={
          holdingClassInvestmentsConsiderationValues
        }
        currency={currency}
      />
      <Typography variant="h5">Per investor allocation</Typography>
      <PerInvestorAllocationTable
        currency={currency}
        investorAllocationsTotals={investorAllocationsTotals}
      />
      <TypographyButton
        textDecoration="none"
        text={
          showPerInvestor
            ? 'Hide investor split by investment'
            : 'See investor split by investment'
        }
        endAdornment={
          showPerInvestor ? (
            <ExpandLess fontSize="small" />
          ) : (
            <ExpandMore fontSize="small" />
          )
        }
        onClick={() => setShowPerInvestor((prev) => !prev)}
      />
      {showPerInvestor && (
        <>
          {groupedPerInvestmentAllocations.map(
            (investmentAllocation: Array<InvestmentAllocation>) => {
              if (investmentAllocation.length === 0) return null;
              return (
                <InvestmentSplitPerInvestorTable
                  key={`${investmentAllocation[0].investmentId}-table`}
                  currency={currency}
                  considerationIndex={considerationIndex}
                  investmentAllocation={investmentAllocation}
                  flatInvestmentAllocations={flatInvestmentAllocations ?? []}
                />
              );
            },
          )}
        </>
      )}
    </>
  );
};

export default AllocationsTableSection;
